// Coordinates are % of the real screenshots (16:9, ScreenView 2 layout); path points are [x, y, seconds].
export const SCENES = [
  {
    img: "access", step: "Connexion en un clic", duration: 6,
    cap: "Le poste du client apparaît en ligne : un clic suffit pour s'y connecter.",
    path: [[42, 80, 0], [52, 40, 1.2], [63.8, 12.1, 2.4], [63.8, 12.1, 6]],
    clicks: [{ x: 63.8, y: 12.1, at: 2.5 }],
    items: [
      { type: "ring", x: 18.8, y: 10.3, w: 24.9, h: 7.9, at: 1 },
      { type: "toast", x: 50, y: 20, text: "Connexion à MAC-STUDIO-GRAPHISME…", at: 2.9 },
    ],
  },
  {
    img: "session", step: "Contrôle à distance", duration: 6.5,
    cap: "Vous voyez et pilotez l'écran du poste en direct, comme si vous étiez devant.",
    path: [[50, 50, 0], [72, 55.4, 1.2], [65.4, 68, 2.2], [65.4, 68, 2.8], [36, 47.8, 4.2], [36, 47.8, 6.5]],
    clicks: [{ x: 65.4, y: 68, at: 2.3 }, { x: 36, y: 47.8, at: 4.3 }],
    items: [
      { type: "ring", x: 61.1, y: 66.6, w: 8.6, h: 2.9, at: 2.4 },
      { type: "toast", x: 4, y: 88, text: "Session en direct · clavier et souris à distance", at: 0.6 },
    ],
  },
  {
    img: "rmm", step: "Supervision du parc", duration: 6,
    cap: "Le tableau RMM signale les postes à surveiller : ici, un disque presque plein.",
    path: [[40, 90, 0], [58, 82, 1.4], [74, 71, 2.4], [74, 71, 6]],
    clicks: [],
    items: [
      { type: "ring", x: 20.8, y: 68.7, w: 77.1, h: 4.6, at: 1.8 },
      { type: "toast", x: 52, y: 78, text: "PC-COMPTA-02 · disque à 91 % · alerte envoyée", at: 2.7 },
    ],
  },
  {
    img: "software", step: "Installation en masse", duration: 6.5,
    cap: "Cochez les logiciels et les postes : tout s'installe en silence, sans déranger l'utilisateur.",
    path: [[60, 50, 0], [80, 60, 1.4], [88, 76.6, 2.6], [88, 76.6, 6.5]],
    clicks: [{ x: 88, y: 76.6, at: 2.7 }],
    items: [
      { type: "ring", x: 78, y: 74.2, w: 20, h: 4.9, at: 2.2 },
      { type: "toast", x: 49, y: 86, text: "Installation lancée sur 3 postes", at: 3 },
    ],
  },
];
